const path = {
  root: "/",
  auth: {
    signup: "/signup",
    login: "/login",
    forbidden: "/403",
  },
  campaign: {
    root: "/campaign",
    actions: "/actions",
    gifts: "/gifts",
  },
  lost: "/404",
};

export default path;
